import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Features from "@/pages/Features";
import WorkspacesLanding from "@/pages/WorkspacesLanding";
import Showcase from "@/pages/Showcase";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import BookEditor from "@/pages/BookEditor";
import PH360 from "@/pages/ph360/PH360";
import SharePreview from "@/pages/SharePreview";
import AdminFreeUsers from "@/pages/AdminFreeUsers";
import PresetTemplates from "@/pages/PresetTemplates";
import BookTemplates from "@/pages/BookTemplates";
import Workspaces from "@/pages/Workspaces";
import Pricing from "@/pages/Pricing";
import Support from "@/pages/Support";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Clients from "@/pages/Clients";
import ClientPreview from "@/pages/ClientPreview";
import AcceptInvite from "@/pages/AcceptInvite";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-[color:var(--text-muted)]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton duration={2500} />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/features" element={<Features />} />
            <Route path="/workspaces" element={<WorkspacesLanding />} />
            <Route path="/showcase" element={<Showcase />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/support" element={<Support />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/share/:token" element={<SharePreview />} />
            <Route path="/client/:token" element={<ClientPreview />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/book/:id"
              element={
                <Protected>
                  <BookEditor />
                </Protected>
              }
            />
            <Route
              path="/ph360"
              element={
                <Protected>
                  <PH360 />
                </Protected>
              }
            />
            <Route
              path="/admin/free-users"
              element={
                <Protected>
                  <AdminFreeUsers />
                </Protected>
              }
            />
            <Route
              path="/library/preset-templates"
              element={
                <Protected>
                  <PresetTemplates />
                </Protected>
              }
            />
            <Route
              path="/library/book-templates"
              element={
                <Protected>
                  <BookTemplates />
                </Protected>
              }
            />
            <Route
              path="/library/workspaces"
              element={
                <Protected>
                  <Workspaces />
                </Protected>
              }
            />
            <Route
              path="/library/clients"
              element={
                <Protected>
                  <Clients />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
